import React, { Component } from "react";
import UniqueKey from "../common/UniqueKey";
import { UncontrolledTooltip, Badge } from "reactstrap";
import _ from 'lodash';
import { getObjectsObject } from "../oro-module/commonFunctions";



class SelectCustom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ttid: "TTID" + String(Math.round(Math.random() * 1000000000)),
      ttid2: "TTID" + String(Math.round(Math.random() * 1000000000))
    };
  }
  generateID() {
    return this.state.ttid;
  }

  generateID2() {
    return this.state.ttid2;
  }

  handleChange = (e, allOptions) => {
    let mval = e.target.value;
    console.log({ mval })
    let x = this.props.parentState.errorMessages;
    let { LocalVars, currentPage } = this.props.parentState;
    let { onLeave } = this.props.component;

    x[this.props.component.name] = "";
    this.props.liftGlobalState({ name: "errorMessages" }, x);
    this.props.liftState(this.props.component, mval);

    let { productlist } = this.props.parentState.LocalVars;
    if (currentPage === "productlist") {
      if (mval === "Price -- Low to High") {
        productlist = _.orderBy(productlist, ['price'], ['asc']);
        LocalVars['productlist'] = productlist
        this.props.liftGlobalState({ name: "LocalVars" }, LocalVars);
      } else if (mval === "Price -- High to Low") {
        productlist = _.orderBy(productlist, ['price'], ['desc']);
        LocalVars['productlist'] = productlist
        this.props.liftGlobalState({ name: "LocalVars" }, LocalVars);
      } else if (mval === "Popularity") {
        productlist = _.orderBy(productlist, ['rating'], ['desc']);
        LocalVars['productlist'] = productlist
        this.props.liftGlobalState({ name: "LocalVars" }, LocalVars);
      }
    }

    if (onLeave) {
      let { track, action, source, target } = onLeave;
      if (action == 'populate') {
        let popu;
        if (!mval || mval == '') {
          popu = { [track]: mval };
          this.props.liftState({ name: track }, mval);
        } else {
          for (var i = 0; i < allOptions.length; i++) {
            let { value, data } = allOptions[i];
            if (value == mval) {
              popu = getObjectsObject(data, source);
              popu[track] = mval;
            }
          }
          if (popu) {
            this.props.liftGlobalState({ name: target }, popu);
          }
        }
      }
    }
  }

  componentDidMount() {
    let { fileFolder, formState, modalname, pageData } = this.props.parentState;
    let { name, displayData, defaultValue } = this.props.component;

    if (
      pageData && !fileFolder.isOpen &&
      ((!modalname && !pageData[name]) || (modalname && (!pageData[modalname] || !pageData[modalname][name]))) &&
      defaultValue
    ) {
      this.props.liftState(this.props.component, defaultValue);
    }

  }
  render() {


    const { name, label, description, isReadOnly, options } = this.props.component;
    let { currentPage, fileFolder, formState, openmodals, modalname, pageData, LocalVars, errorMessages } = this.props.parentState;
    let { compressed } = LocalVars;
    let boxvalue;
    if (modalname && pageData[modalname]) {
      boxvalue = pageData[modalname][name]
        ? pageData[modalname][name]
        : "";
    } else {
      boxvalue = pageData[name]
        ? pageData[name]
        : "";
    }
    let isReadOnly1 = false;
    let { conditionalRender } = this.props;

    if ((pageData.unique_id && isReadOnly == 'edit') || (conditionalRender && conditionalRender == 'readonly') || (isReadOnly && isReadOnly != 'edit')) {
      isReadOnly1 = true;
    }
    let currentError
    if (errorMessages) {
      if (modalname && errorMessages[modalname] && errorMessages[modalname][name]) {
        currentError = errorMessages[modalname][name];
      } else if (!modalname && errorMessages[name]) {
        currentError = errorMessages[name];
      }
    }

    const tooltipID = this.generateID();
    const tooltipID2 = this.generateID2();
    let allOptions = options instanceof Array ? options : this.props.parentState[options] ? this.props.parentState[options] : [];

    // console.log({ allOptions, conditionalRender })
    return (
      <div
        key={this.props.index}
        className={`form-group ${this.props.component.widths.parent}`}
      >
        {label &&
          label != undefined &&
          label != "" && (
            <span>
              <label
                className="col-form-label col-form-label-sm nopadding"
              >
                {label}
              </label>

            </span>
          )}
        {/* {" " + this.props.parentState.errorMessages != undefined &&
        this.props.parentState.errorMessages[name] ? (
          <span>
           
          </span>
        ) : (
          ""
        )} */}
        {conditionalRender && conditionalRender != 'blank' &&
          <div className="input-group input-group-sm">
            {this.props.component.prepend && (
              <div className="input-group-prepend">
                <div className="input-group-text">
                  {this.props.component.prepend}
                </div>
              </div>
            )}
            {/* {this.props.component.prepend && this.props.component.prepend!="" &&
             <span style={{marginRight:"10px" }}>{this.props.component.prepend}</span>  for label
          } */}
            <select
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${currentError
                ? "validationErrorBox"
                : ""
                } ${!compressed ? "select-compressed" : ""}`}
              readOnly={isReadOnly1}
              name={name}
              value={boxvalue}
              onChange={(e) => this.handleChange(e, allOptions)}
            >
              <option value="">Select {label}</option>
              {conditionalRender && conditionalRender != 'readonly' && isReadOnly1 != true && allOptions.map((val, index) => {
                return (
                  <option key={index} value={val.value}>
                    {val.label}
                  </option>
                );
              })}

              {isReadOnly1 == true && boxvalue && boxvalue != "" &&
                <option value={boxvalue}>
                  {boxvalue}
                </option>
              }


            </select>


            {this.props.component.append && (
              <div className="input-group-append">
                <div className="input-group-text">
                  {this.props.component.append}
                </div>
              </div>
            )}
          </div>
        }
      </div>
    );
  }
}

export default SelectCustom;
